var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("b-loading", {
        attrs: {
          "is-full-page": _vm.isFullPage,
          active: _vm.isLoading,
          "can-cancel": true
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("div", { attrs: { id: "header" } }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "content content-components" }, [
        _c("div", { staticClass: "container pd-x-0 pd-lg-x-12 pd-xl-x-0 bs" }, [
          _c(
            "div",
            {
              staticClass:
                "d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30"
            },
            [
              _c("div", [
                _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
                  _c(
                    "ol",
                    { staticClass: "breadcrumb breadcrumb-style1 mg-b-10" },
                    [
                      _c("li", { staticClass: "breadcrumb-item" }, [
                        _vm._v(_vm._s(this.mainName))
                      ]),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "breadcrumb-item active",
                          attrs: { "aria-current": "page" }
                        },
                        [_vm._v(_vm._s(this.subName))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "mg-b-0 tx-spacing--1" }, [
                    _vm._v(_vm._s(this.subName))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-none d-md-block" }, [
                this.properties.uid
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm pd-x-15 btn-danger btn-uppercase mg-l-5",
                        on: {
                          click: function($event) {
                            return _vm.deleteData()
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "wd-10 mg-r-5",
                          attrs: { "data-feather": "folder" }
                        }),
                        _vm._v("Delete")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                    on: {
                      click: function($event) {
                        return _vm.createData()
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "wd-10 mg-r-5",
                      attrs: { "data-feather": "folder" }
                    }),
                    _vm._v("Save")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                    on: {
                      click: function($event) {
                        return _vm.goList()
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "wd-10 mg-r-5",
                      attrs: { "data-feather": "file" }
                    }),
                    _vm._v("list")
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mg-t-100 bs2" }, [
            _c("div", { staticClass: "card ht-100p" }, [
              _c(
                "form",
                {
                  staticClass:
                    "card-body list-group list-group-flush tx-13list-group list-group-flush tx-13 d-block",
                  attrs: {
                    action: "form-validation.html",
                    "data-parsley-validate": ""
                  }
                },
                [
                  _c("div", { staticClass: "form-row col-md-5 d-block" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.name,
                            expression: "name",
                            modifiers: { trim: true }
                          }
                        ],
                        ref: "name",
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "name",
                          placeholder: "Pipeline Name"
                        },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row col-md-5 " }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _vm._m(2),
                        _vm._v(" "),
                        _c(
                          "b-select",
                          {
                            attrs: { placeholder: "Select a Pipeline" },
                            nativeOn: {
                              change: function($event) {
                                return _vm.selTaskHandler()
                              }
                            },
                            model: {
                              value: _vm.selTask,
                              callback: function($$v) {
                                _vm.selTask = $$v
                              },
                              expression: "selTask"
                            }
                          },
                          _vm._l(_vm.task, function(option) {
                            return _c(
                              "option",
                              { domProps: { value: option } },
                              [
                                _vm._v(
                                  "\n                                            " +
                                    _vm._s(option.name) +
                                    "\n                                        "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        staticStyle: { "margin-left": "20px" }
                      },
                      [
                        _vm._m(3),
                        _vm._v(" "),
                        _c(
                          "b-select",
                          {
                            ref: "resultMenu",
                            attrs: { placeholder: "Select a Result" },
                            nativeOn: { change: function($event) {} },
                            model: {
                              value: _vm.resultMenu,
                              callback: function($$v) {
                                _vm.resultMenu = $$v
                              },
                              expression: "resultMenu"
                            }
                          },
                          _vm._l(_vm.resultMenu_array, function(option) {
                            return _c(
                              "option",
                              { domProps: { value: option.menuId } },
                              [
                                _vm._v(
                                  "\n                                            " +
                                    _vm._s(option.menuName) +
                                    "\n                                        "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row col-md-5" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _vm._m(4),
                        _vm._v(" "),
                        _c(
                          "b-field",
                          [
                            _c(
                              "b-switch",
                              {
                                attrs: {
                                  type: "is-info",
                                  "true-value": "Yes",
                                  "false-value": "No"
                                },
                                nativeOn: {
                                  change: function($event) {
                                    return _vm.defaultCheck()
                                  }
                                },
                                model: {
                                  value: _vm.defaultSwitched,
                                  callback: function($$v) {
                                    _vm.defaultSwitched = $$v
                                  },
                                  expression: "defaultSwitched"
                                }
                              },
                              [
                                _vm._v(
                                  "\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(_vm.defaultSwitched) +
                                    "\n\t\t\t\t\t\t\t\t\t\t"
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row col-md-5" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(5),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group" }, [
                        _c(
                          "div",
                          {
                            staticClass: "ml-2 custom-control custom-radio mb-1"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.type,
                                  expression: "type",
                                  modifiers: { trim: true }
                                }
                              ],
                              ref: "type",
                              staticClass: "custom-control-input",
                              attrs: {
                                type: "radio",
                                name: "type",
                                id: "type1",
                                value: "single"
                              },
                              domProps: { checked: _vm._q(_vm.type, "single") },
                              on: {
                                change: [
                                  function($event) {
                                    _vm.type = "single"
                                  },
                                  function($event) {
                                    return _vm.typeCheck($event, 1)
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: "type1" }
                              },
                              [_vm._v("Single")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2 custom-control custom-radio mb-1"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.type,
                                  expression: "type",
                                  modifiers: { trim: true }
                                }
                              ],
                              ref: "type",
                              staticClass:
                                "custom-control-input form-check-input",
                              attrs: {
                                type: "radio",
                                name: "type",
                                id: "type0",
                                value: "group"
                              },
                              domProps: { checked: _vm._q(_vm.type, "group") },
                              on: {
                                change: [
                                  function($event) {
                                    _vm.type = "group"
                                  },
                                  function($event) {
                                    return _vm.typeCheck($event, 0)
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: "type0" }
                              },
                              [_vm._v("Group")]
                            )
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row col-md-5" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(6),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group" }, [
                        _c(
                          "div",
                          {
                            staticClass: "ml-2 custom-control custom-radio mb-1"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.remoteHost,
                                  expression: "remoteHost",
                                  modifiers: { trim: true }
                                }
                              ],
                              ref: "remoteHost",
                              staticClass: "custom-control-input",
                              attrs: {
                                type: "radio",
                                name: "remoteHost",
                                id: "remoteHost1",
                                value: "accu01"
                              },
                              domProps: {
                                checked: _vm._q(_vm.remoteHost, "accu01")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    _vm.remoteHost = "accu01"
                                  },
                                  function($event) {
                                    return _vm.serverCheck($event, 1)
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: "remoteHost1" }
                              },
                              [_vm._v("accu01")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2 custom-control custom-radio mb-1"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.remoteHost,
                                  expression: "remoteHost",
                                  modifiers: { trim: true }
                                }
                              ],
                              ref: "remoteHost",
                              staticClass:
                                "custom-control-input form-check-input",
                              attrs: {
                                type: "radio",
                                name: "remoteHost",
                                id: "remoteHost0",
                                value: "accu02"
                              },
                              domProps: {
                                checked: _vm._q(_vm.remoteHost, "accu02")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    _vm.remoteHost = "accu02"
                                  },
                                  function($event) {
                                    return _vm.serverCheck($event, 0)
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: "remoteHost0" }
                              },
                              [_vm._v("accu02")]
                            )
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row col-md-5 d-block" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(7),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.remoteUserName,
                            expression: "remoteUserName",
                            modifiers: { trim: true }
                          }
                        ],
                        ref: "remoteUserName",
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "remoteUserName",
                          placeholder: "Pipeline Execution Shell Script RunFile"
                        },
                        domProps: { value: _vm.remoteUserName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.remoteUserName = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row col-md-5" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(8),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group" }, [
                        _c(
                          "div",
                          {
                            staticClass: "ml-2 custom-control custom-radio mb-1"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.fileExtension,
                                  expression: "fileExtension",
                                  modifiers: { trim: true }
                                }
                              ],
                              ref: "fileExtension",
                              staticClass: "custom-control-input",
                              attrs: {
                                type: "radio",
                                name: "fileExtension",
                                id: "fileExtension1",
                                value: "python"
                              },
                              domProps: {
                                checked: _vm._q(_vm.fileExtension, "python")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    _vm.fileExtension = "python"
                                  },
                                  function($event) {
                                    return _vm.extensionCheck($event, 1)
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: "fileExtension1" }
                              },
                              [_vm._v("Python")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2 custom-control custom-radio mb-1"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.fileExtension,
                                  expression: "fileExtension",
                                  modifiers: { trim: true }
                                }
                              ],
                              ref: "fileExtension",
                              staticClass:
                                "custom-control-input form-check-input",
                              attrs: {
                                type: "radio",
                                name: "fileExtension",
                                id: "fileExtension0",
                                value: "shell"
                              },
                              domProps: {
                                checked: _vm._q(_vm.fileExtension, "shell")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    _vm.fileExtension = "shell"
                                  },
                                  function($event) {
                                    return _vm.extensionCheck($event, 0)
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: "fileExtension0" }
                              },
                              [_vm._v("Shell")]
                            )
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row col-md-5 d-block" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(9),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.runFile,
                            expression: "runFile",
                            modifiers: { trim: true }
                          }
                        ],
                        ref: "runFile",
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "runFile",
                          placeholder: "Pipeline Execution Shell Script RunFile"
                        },
                        domProps: { value: _vm.runFile },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.runFile = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  this.type == "single"
                    ? _c("div", { staticClass: "form-row col-md-5 d-block" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _vm._m(10),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.reportDataFile,
                                expression: "reportDataFile",
                                modifiers: { trim: true }
                              }
                            ],
                            ref: "reportDataFile",
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              id: "reportDataFile",
                              placeholder:
                                "Pipeline Execution Shell Script ReportDataFile"
                            },
                            domProps: { value: _vm.reportDataFile },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.reportDataFile = $event.target.value.trim()
                              },
                              blur: function($event) {
                                return _vm.$forceUpdate()
                              }
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  this.type == "single"
                    ? _c("div", { staticClass: "form-row col-md-5 d-block" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _vm._m(11),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.reporterFile,
                                expression: "reporterFile",
                                modifiers: { trim: true }
                              }
                            ],
                            ref: "reporterFile",
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              id: "reporterFile",
                              placeholder:
                                "Pipeline Execution Shell Script ReporterFile "
                            },
                            domProps: { value: _vm.reporterFile },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.reporterFile = $event.target.value.trim()
                              },
                              blur: function($event) {
                                return _vm.$forceUpdate()
                              }
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row col-md-5 d-block" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(12),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.outPutDir,
                            expression: "outPutDir",
                            modifiers: { trim: true }
                          }
                        ],
                        ref: "outPutDir",
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "outPutDir",
                          placeholder: "Please set the outPutDir"
                        },
                        domProps: { value: _vm.outPutDir },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.outPutDir = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row col-md-12 d-block" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "input4" } }, [
                          _vm._v("Parameter")
                        ]),
                        _c(
                          "a",
                          {
                            staticClass:
                              "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 mg-sm-b-10-f",
                            attrs: {
                              href: "",
                              "data-toggle": "modal",
                              "data-animation": "effect-flip-horizontal"
                            },
                            on: { click: _vm.addParameter }
                          },
                          [
                            _c("feather", {
                              staticClass:
                                "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                              attrs: { type: "plus" }
                            }),
                            _vm._v("Add")
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.param_array, function(form, i) {
                          return _c(
                            "div",
                            [
                              _c("feather", {
                                staticClass:
                                  "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow closed-cursor",
                                attrs: { type: "minus" },
                                on: {
                                  click: function($event) {
                                    return _vm.delParameter(i)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "b-tooltip",
                                {
                                  attrs: {
                                    label: "key",
                                    position: "is-bottom",
                                    animated: false
                                  }
                                },
                                [
                                  _c("input", {
                                    staticClass: "form-control d-inline w-auto",
                                    attrs: {
                                      type: "text",
                                      id: "key" + i,
                                      placeholder: "key"
                                    },
                                    domProps: { value: form.key },
                                    on: {
                                      change: function($event) {
                                        return _vm.chgParameter(
                                          i,
                                          "key",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tooltip",
                                {
                                  attrs: {
                                    label: "value",
                                    position: "is-bottom",
                                    animated: false
                                  }
                                },
                                [
                                  _c("input", {
                                    staticClass: "form-control d-inline w-auto",
                                    attrs: {
                                      type: "text",
                                      id: "value" + i,
                                      placeholder: "value"
                                    },
                                    domProps: { value: form.value },
                                    on: {
                                      change: function($event) {
                                        return _vm.chgParameter(
                                          i,
                                          "value",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tooltip",
                                {
                                  attrs: {
                                    label: "description",
                                    position: "is-bottom",
                                    animated: false
                                  }
                                },
                                [
                                  _c("input", {
                                    staticClass: "form-control d-inline",
                                    attrs: {
                                      type: "text",
                                      id: "message" + i,
                                      placeholder: "description"
                                    },
                                    domProps: { value: form.message },
                                    on: {
                                      change: function($event) {
                                        return _vm.chgParameter(
                                          i,
                                          "message",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "field d-inline" },
                                [
                                  _c(
                                    "b-checkbox",
                                    {
                                      attrs: {
                                        id: "fixed" + i,
                                        "true-value": "true",
                                        "false-value": "false",
                                        value: form.fixed,
                                        type: "is-info"
                                      },
                                      nativeOn: {
                                        change: function($event) {
                                          return _vm.chgParameter(
                                            i,
                                            "fixed",
                                            $event
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Fixed")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ])
                ]
              )
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass: "sidebar sidebar-fixed bg-white",
          attrs: { id: "sidebarMenu" }
        },
        [
          _c("div", { staticClass: "sidebar-header" }, [
            _c("h5", [_vm._v("Search")]),
            _vm._v(" "),
            _c("a", { attrs: { href: "", id: "sidebarMenuClose" } }, [
              _c("i", { attrs: { "data-feather": "x" } })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sidebar-body" })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input1" } }, [
      _vm._v("Pipeline Name "),
      _c("span", { staticClass: "tx-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input1" } }, [
      _vm._v("Existing Pipeline "),
      _c("span", { staticClass: "tx-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input1" } }, [
      _vm._v("Result "),
      _c("span", { staticClass: "tx-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input1" } }, [
      _vm._v("Default "),
      _c("span", { staticClass: "tx-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "label-title" }, [
      _vm._v("type "),
      _c("span", { staticClass: "tx-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "label-title" }, [
      _vm._v("Server Remote Host "),
      _c("span", { staticClass: "tx-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input4" } }, [
      _vm._v("Server User Name "),
      _c("span", { staticClass: "tx-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "label-title" }, [
      _vm._v("FileName Extension "),
      _c("span", { staticClass: "tx-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input4" } }, [
      _vm._v("Pipeline Execution Shell Script RunFile "),
      _c("span", { staticClass: "tx-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input4" } }, [
      _vm._v("Pipeline Execution Shell Script ReportDataFile  "),
      _c("span", { staticClass: "tx-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input4" } }, [
      _vm._v("Pipeline Execution Shell Script ReporterFile  "),
      _c("span", { staticClass: "tx-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input4" } }, [
      _vm._v("OutPutDir  "),
      _c("span", { staticClass: "tx-danger" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d52b1a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d52b1a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Analysis/Pipeline/TaskDetailForm.vue
// module id = null
// module chunks = 